import { Divider, Grid } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { getPermissions } from "../../commonFunctions/PermissionManger";
import {
  getLocalValue,
  IRoleMain,
  LoacalVariables,
  MasterPages
} from "../../commonFunctions/CommonFunctions";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import { HeaderList } from "../../Components/Header/HeaderList";
import PermissionDenied from "../../commonFunctions/PermissionDenied";

export const ServiceList: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  const { edit, add, view, exports } = getPermissions(
    MasterPages.Services,
    IRoleMain.Masters
  );

  const [totalCount, setTotalCount] = useState<any>();
  const source = {
    url: "laundry-services/search",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: []
  };

  /**
   *  Edit function
   * @param action
   * @param row
   */
  const handleAction = (action: string, row: any) => {
    if (action === "Edit") {
      navigate(`/service/${row?.serviceId}`);
    }
  };

  const columns: IColumns[] = [
    {
      header: "Service",
      fieldName: "serviceName",
      type: "default"
    },

    {
      header: "Short Name",
      fieldName: "shortName",
      type: "default"
    },

    {
      header: "Description",
      fieldName: "description",
      tooltip: true,
      type: "default"
    },

    {
      header: "Base",
      fieldName: "basePrice"
    },

    {
      header: "Weight",
      fieldName: "weightPrice"
    },

    {
      header: "ServicePrice",
      fieldName: "urgentServicePrice",
      type: "default"
    },

    // {
    //   header: "CompletionTime",
    //   fieldName: "estimatedCompletionTime",
    // },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [edit ? "Edit" : undefined],
      actionCallback: (action, row) => handleAction(action, row)
    }
  ];

  const handleClick = () => {
    navigate("/service");
  };
  const transFormData = (data: any, totalCount: any) => {
    setTotalCount(totalCount);
    return data;
  };
  return (
    <>
      <HeaderList
        title="Services"
        type="card"
        info={`${totalCount || 0} Total Records`}
      />
      {view ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <WSDataGrid
              id="serviceGrid"
              title="Services"
              columns={columns}
              headerType="HaderTopCornered"
              source={source}
              exportCsv={exports}
              addButton={add ? { label: "", color: "secondary" } : undefined}
              onAddButtonClick={handleClick}
              transFormData={transFormData}
            />
          </Grid>
        </Grid>
      ) : (
        <PermissionDenied />
      )}
    </>
  );
});
